(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.slides = Array.from(this.querySelectorAll('[data-announcement-slide]'));
      this.currentIndex = 0;
      this.timer = null;
      this.interval = Number(this.dataset.interval) || 5000;
      this.rotationEnabled = this.dataset.rotation === 'true';
      const closeButton = this.querySelector('.announcement__close');
      const dismissed = window.sessionStorage.getItem('announcementDismissed');

      if (!dismissed) {
        this.classList.remove('hide');
      }

      if (closeButton) {
        closeButton.addEventListener('click', this.hideAnnouncement.bind(this));
      }

      if (this.rotationEnabled && this.slides.length > 1) {
        this.setSlideClasses();
        this.startRotation();

        this.addEventListener('mouseenter', this.stopRotation.bind(this));
        this.addEventListener('mouseleave', this.startRotation.bind(this));
        this.addEventListener('focusin', this.stopRotation.bind(this));
        this.addEventListener('focusout', this.startRotation.bind(this));
      }
    }

    disconnectedCallback() {
      this.stopRotation();
    }

    setSlideClasses(previousIndex = null) {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;

      this.slides.forEach((slide, index) => {
        slide.classList.remove('is-active', 'is-prev', 'is-next');

        if (index === this.currentIndex) {
          slide.classList.add('is-active');
        } else if (index === previousIndex) {
          slide.classList.add('is-prev');
        } else if (index === nextIndex) {
          slide.classList.add('is-next');
        }
      });
    }

    showNextSlide() {
      const previousIndex = this.currentIndex;
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      this.setSlideClasses(previousIndex);
    }

    startRotation() {
      this.stopRotation();

      if (this.rotationEnabled && this.slides.length > 1) {
        this.timer = window.setInterval(this.showNextSlide.bind(this), this.interval);
      }
    }

    stopRotation() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    hideAnnouncement() {
      window.sessionStorage.setItem('announcementDismissed', true);
      this.stopRotation();
      this.classList.add('announcement-bar--hide');

      setTimeout(() => {
        this.style.display = 'none';
      }, 300);
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artistic-hexagon-brand-logos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const getPreview = (trigger) => {
      const previewId = trigger.getAttribute('aria-controls');
      return previewId ? document.getElementById(previewId) : null;
    };

    const elevatePreview = (preview, trigger) => {
      if (preview.dataset.hexagonPreviewElevated === 'true') return;

      const section = trigger.closest('[data-hexagon-partners]');
      if (section) {
        const styles = window.getComputedStyle(section);
        const colorChannels = (color) => color.match(/[\d.]+/g)?.slice(0, 3).join(', ');
        const background = styles.getPropertyValue('--color-background').trim() || colorChannels(styles.backgroundColor);
        const foreground = colorChannels(styles.color);

        if (background) preview.style.setProperty('--hexagon-preview-background', background);
        if (foreground) preview.style.setProperty('--hexagon-preview-foreground', foreground);
      }

      document.body.append(preview);
      preview.dataset.hexagonPreviewElevated = 'true';
    };

    const placePreview = (trigger) => {
      if (!window.matchMedia('(min-width: 750px)').matches) return;

      const preview = getPreview(trigger);
      if (!preview) return;

      const triggerRect = trigger.getBoundingClientRect();
      const previewWidth = preview.offsetWidth;
      const previewHeight = preview.offsetHeight;
      const viewportWidth = document.documentElement.clientWidth;
      const viewportHeight = document.documentElement.clientHeight;
      const edgeSpacing = 16;
      const triggerSpacing = 18;

      if (!previewWidth || !previewHeight) return;

      const preferredSide = triggerRect.left + triggerRect.width / 2 <= viewportWidth / 2 ? 'right' : 'left';
      const alternativeSide = preferredSide === 'right' ? 'left' : 'right';
      const leftForSide = (side) => side === 'right'
        ? triggerRect.right + triggerSpacing
        : triggerRect.left - previewWidth - triggerSpacing;
      const fitsHorizontally = (left) => left >= edgeSpacing && left + previewWidth <= viewportWidth - edgeSpacing;
      let side = preferredSide;
      let left = leftForSide(side);

      if (!fitsHorizontally(left)) {
        const alternativeLeft = leftForSide(alternativeSide);
        if (fitsHorizontally(alternativeLeft)) {
          side = alternativeSide;
          left = alternativeLeft;
        }
      }

      left = Math.max(edgeSpacing, Math.min(left, viewportWidth - previewWidth - edgeSpacing));

      const desiredCenterY = triggerRect.top + triggerRect.height / 2;
      const minCenterY = Math.min(viewportHeight / 2, previewHeight / 2 + edgeSpacing);
      const maxCenterY = Math.max(viewportHeight / 2, viewportHeight - previewHeight / 2 - edgeSpacing);
      const top = Math.max(minCenterY, Math.min(desiredCenterY, maxCenterY));

      preview.style.setProperty('--hexagon-preview-x', `${Math.round(left)}px`);
      preview.style.setProperty('--hexagon-preview-y', `${Math.round(top)}px`);
      preview.dataset.previewSide = side;
    };

    const placeOpenPreviews = () => {
      document.querySelectorAll('[data-hexagon-preview-trigger].is-preview-open').forEach(placePreview);
    };

    const closeOpenPreviews = () => {
      document.querySelectorAll('[data-hexagon-preview-trigger].is-preview-open').forEach((trigger) => {
        trigger.classList.remove('is-preview-open');
        trigger.setAttribute('aria-expanded', 'false');
        getPreview(trigger)?.classList.remove('is-preview-open');
        trigger.closest('[data-hexagon-partners]')?.dispatchEvent(new Event('hexagon:preview-change'));
      });
    };

    const initializeMarquee = (section, closeAll) => {
      const track = section.querySelector('[data-hexagon-track]');
      const row = track?.querySelector('.hexagon-partners__row');
      if (!track || !row) return () => {};
      const originals = Array.from(row.children);
      const group = document.createElement('div');
      group.className = 'hexagon-partners__group';
      group.append(...originals);
      row.append(group);
      let copy = null;
      let repeatCount = 0;
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const mobile = matchMedia('(max-width: 749px)');
      const direction = section.dataset.autoplayDirection === 'right' ? -1 : 1;
      const resumeDelay = Math.max(1, Number(section.dataset.autoplayResumeDelay) || 3) * 1000;
      const cleanups = [];
      let step = 0;
      let period = 0;
      let duration = 0;
      let layoutFrame = null;
      let resumeTimer = null;
      let resumeAt = 0;
      let interacting = false;
      let editorPaused = false;
      let previewOpen = false;
      let enabled = false;
      let destroyed = false;
      let pointerId = null;
      let pointerStartX = 0;
      let pointerStartY = 0;
      let pointerLastX = 0;
      let dragging = false;
      let suppressClickUntil = 0;

      const listen = (target, type, callback, options) => {
        target.addEventListener(type, callback, options);
        cleanups.push(() => target.removeEventListener(type, callback, options));
      };
      const animation = () => row.getAnimations().find(item => item.animationName === 'hexagon-partners-marquee');
      const canRun = () => !destroyed && enabled && !document.hidden && !editorPaused && !previewOpen
        && !interacting && Date.now() >= resumeAt && !track.contains(document.activeElement)
        && !(track.matches(':hover') && section.dataset.autoplayPauseHover !== 'false');
      const updatePlayback = () => {
        if (destroyed) return;
        const running = canRun();
        if (running) absorbNativeScroll();
        row.style.setProperty('--hexagon-loop-play-state', running ? 'running' : 'paused');
      };
      // CSS owns the animation. Seek only for manual input or a real geometry change.
      const currentOffset = () => {
        const transform = getComputedStyle(row).transform;
        return transform === 'none' ? 0 : -new DOMMatrixReadOnly(transform).m41;
      };
      const seek = (offset) => {
        if (!period || !duration) return;
        const normalized = ((offset % period) + period) % period;
        const progress = normalized / period;
        const motion = animation();
        if (motion) motion.currentTime = (direction === 1 ? progress : 1 - progress) * duration;
      };
      const advance = (distance) => {
        if (enabled) seek(currentOffset() + distance);
      };
      const absorbNativeScroll = () => {
        if (!enabled || !track.scrollLeft) return;
        const distance = track.scrollLeft;
        track.scrollLeft = 0;
        advance(distance);
      };
      const deferResume = () => {
        resumeAt = Date.now() + resumeDelay;
        if (resumeTimer !== null) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(() => { resumeTimer = null; updatePlayback(); }, resumeDelay);
        updatePlayback();
      };
      const cloneItem = (item) => {
        const clone = item.cloneNode(true);
        clone.dataset.hexagonRepeat = '';
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[data-hexagon-preview]').forEach(preview => preview.remove());
        [clone, ...clone.querySelectorAll('*')].forEach(node => {
          node.removeAttribute('id');
          node.removeAttribute('data-shopify-editor-block');
          node.removeAttribute('data-shopify-editor-block-ide');
        });
        clone.querySelectorAll('button, a, [tabindex]').forEach(node => {
          node.setAttribute('tabindex', '-1');
          node.classList.remove('is-preview-open');
          if (node.hasAttribute('aria-expanded')) node.setAttribute('aria-expanded', 'false');
        });
        // All instances use the same image URL and original tooltip owner.
        clone.querySelectorAll('.hexagon-partners__logo').forEach(image => { image.loading = 'eager'; });
        return clone;
      };
      const updateLayout = () => {
        layoutFrame = null;
        if (destroyed) return;
        const wasEnabled = enabled;
        const previousStep = step;
        const previousPeriod = period;
        const previousDuration = duration;
        const offset = wasEnabled ? currentOffset() : 0;
        // Width affects coverage, never whether autoplay is allowed.
        enabled = section.dataset.autoplay !== 'false' && !reducedMotion.matches && originals.length > 0;
        track.classList.toggle('hexagon-partners__mosaic--looping', enabled);
        if (!enabled) {
          if (wasEnabled) closeAll();
          track.scrollLeft = 0;
          updatePlayback();
          return;
        }
        const gap = parseFloat(getComputedStyle(group).columnGap) || 0;
        step = (originals[0]?.getBoundingClientRect().width || 0) + gap;
        const basePeriod = originals.reduce((sum, item) => sum + item.getBoundingClientRect().width + gap, 0);
        // Fill a wide viewport by repeating the WHOLE ordered sequence in both groups.
        const needed = basePeriod > 0 ? Math.max(1, Math.ceil((track.clientWidth + step) / basePeriod)) : 1;
        if (repeatCount !== needed) {
          group.querySelectorAll('[data-hexagon-repeat]').forEach(item => item.remove());
          for (let index = 1; index < needed; index++) group.append(...originals.map(cloneItem));
          copy?.remove();
          copy = group.cloneNode(false);
          copy.classList.add('hexagon-partners__group--copy');
          copy.setAttribute('aria-hidden', 'true');
          Array.from(group.children).forEach(item => copy.append(cloneItem(item)));
          row.append(copy);
          repeatCount = needed;
        }
        // Includes the trailing gap: second group's start is exactly one period away.
        period = group.getBoundingClientRect().width;
        const speed = Math.min(120, Math.max(5, Number(mobile.matches ? section.dataset.autoplaySpeedMobile : section.dataset.autoplaySpeed) || 25));
        duration = Math.max(1, period / speed * 1000);
        if (!wasEnabled || period !== previousPeriod || duration !== previousDuration || step !== previousStep) {
          row.style.setProperty('--hexagon-loop-distance', `${period}px`);
          row.style.setProperty('--hexagon-loop-duration', `${duration}ms`);
          row.style.setProperty('--hexagon-loop-direction', direction === 1 ? 'normal' : 'reverse');
          // Preserve the currently visible logo and its within-tile position, even
          // when crossing the mobile breakpoint or changing the repetition count.
          seek(previousStep > 0 ? offset / previousStep * step : offset);
          if (wasEnabled) closeAll();
        }
        track.scrollLeft = 0;
        updatePlayback();
      };
      const scheduleLayout = () => {
        if (!destroyed && layoutFrame === null) layoutFrame = requestAnimationFrame(updateLayout);
      };
      listen(track, 'pointerenter', (event) => {
        if (event.pointerType === 'touch') return;
        updatePlayback();
      });
      listen(track, 'pointerleave', updatePlayback);
      listen(track, 'pointerdown', (event) => {
        if (!enabled || event.button !== 0) return;
        pointerId = event.pointerId;
        pointerStartX = pointerLastX = event.clientX;
        pointerStartY = event.clientY;
        dragging = false;
        suppressClickUntil = 0;
        interacting = true;
        absorbNativeScroll();
        deferResume();
      }, { passive: true });
      listen(window, 'pointermove', (event) => {
        if (!enabled || pointerId !== event.pointerId) return;
        if (!dragging) {
          const dx = Math.abs(event.clientX - pointerStartX);
          const dy = Math.abs(event.clientY - pointerStartY);
          if (dx < 6 || dx <= dy) return;
          dragging = true;
          closeAll();
          track.setPointerCapture(event.pointerId);
        }
        if (event.cancelable) event.preventDefault();
        advance(pointerLastX - event.clientX);
        pointerLastX = event.clientX;
      }, { passive: false });
      const releasePointer = (event) => {
        if (pointerId !== event.pointerId) return;
        if (dragging) suppressClickUntil = Date.now() + 300;
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        pointerId = null;
        dragging = false;
        interacting = false;
        deferResume();
      };
      listen(window, 'pointerup', releasePointer, { passive: true });
      listen(window, 'pointercancel', releasePointer, { passive: true });
      listen(track, 'click', (event) => {
        if (event.detail > 0 && Date.now() < suppressClickUntil) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);
      listen(track, 'wheel', (event) => {
        if (!enabled) { deferResume(); return; }
        const distance = event.deltaX || (event.shiftKey ? event.deltaY : 0);
        if (!distance) return;
        event.preventDefault();
        closeAll();
        absorbNativeScroll();
        advance(distance * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? track.clientWidth : 1));
        deferResume();
      }, { passive: false });
      listen(track, 'keydown', (event) => {
        const distance = { ArrowLeft: -40, ArrowRight: 40, PageUp: -track.clientWidth, PageDown: track.clientWidth }[event.key];
        if (!enabled || distance === undefined) return;
        event.preventDefault();
        closeAll();
        absorbNativeScroll();
        advance(distance);
        deferResume();
      });
      listen(track, 'focusin', updatePlayback);
      listen(track, 'focusout', () => queueMicrotask(updatePlayback));
      listen(document, 'visibilitychange', updatePlayback);
      listen(section, 'hexagon:preview-change', () => {
        previewOpen = !!section.querySelector('[data-hexagon-preview-trigger].is-preview-open');
        updatePlayback();
      });
      listen(reducedMotion, 'change', scheduleLayout);
      listen(mobile, 'change', scheduleLayout);
      listen(window, 'resize', scheduleLayout);
      listen(document, 'shopify:block:select', (event) => {
        if (!section.contains(event.target)) return;
        editorPaused = true;
        updatePlayback();
        event.target.closest('.hexagon-partners__item')?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
      });
      listen(document, 'shopify:block:deselect', (event) => {
        if (!section.contains(event.target)) return;
        editorPaused = false;
        deferResume();
      });
      // Tile dimensions are CSS-defined; image load/error still reconciles layout.
      group.querySelectorAll('.hexagon-partners__logo').forEach(image => {
        listen(image, 'load', scheduleLayout);
        listen(image, 'error', scheduleLayout);
      });
      const resizeObserver = new ResizeObserver(scheduleLayout);
      resizeObserver.observe(track);
      resizeObserver.observe(group);
      updateLayout();
      return () => {
        destroyed = true;
        if (layoutFrame !== null) cancelAnimationFrame(layoutFrame);
        if (resumeTimer !== null) clearTimeout(resumeTimer);
        resizeObserver.disconnect();
        cleanups.forEach(cleanup => cleanup());
        closeAll();
        row.append(...originals);
        group.remove();
        copy?.remove();
        ['--hexagon-loop-distance', '--hexagon-loop-duration', '--hexagon-loop-direction', '--hexagon-loop-play-state']
          .forEach(property => row.style.removeProperty(property));
        track.classList.remove('hexagon-partners__mosaic--looping');
      };
    };

    const initialize = (scope = document) => {
      const sections = scope.matches?.('[data-hexagon-partners]') ? [scope] : scope.querySelectorAll?.('[data-hexagon-partners]');
      if (!sections) return;
      sections.forEach((section) => {
        if (section.dataset.hexagonPartnersInitialized === 'true') return;
        section.dataset.hexagonPartnersInitialized = 'true';
        const closeAll = (except = null) => {
          section.querySelectorAll('[data-hexagon-preview-trigger].is-preview-open').forEach((trigger) => {
            if (trigger === except) return;
            trigger.classList.remove('is-preview-open');
            trigger.setAttribute('aria-expanded', 'false');
            getPreview(trigger)?.classList.remove('is-preview-open');
          });
          section.dispatchEvent(new Event('hexagon:preview-change'));
        };
        const setOpen = (trigger, isOpen) => {
          const preview = getPreview(trigger);
          if (isOpen) {
            closeAll(trigger);
            if (preview) elevatePreview(preview, trigger);
            placePreview(trigger);
          }
          preview?.classList.toggle('is-preview-open', isOpen);
          trigger.classList.toggle('is-preview-open', isOpen);
          trigger.setAttribute('aria-expanded', String(isOpen));
          section.dispatchEvent(new Event('hexagon:preview-change'));
        };
        const getTrigger = target => target instanceof Element ? target.closest('[data-hexagon-preview-trigger]') : null;
        const listeners = {
          mouseover: event => {
            const trigger = getTrigger(event.target);
            if (trigger && !trigger.contains(event.relatedTarget) && matchMedia('(hover: hover)').matches) setOpen(trigger, true);
          },
          mouseout: event => {
            const trigger = getTrigger(event.target);
            if (trigger && !trigger.contains(event.relatedTarget) && document.activeElement !== trigger && matchMedia('(hover: hover)').matches) setOpen(trigger, false);
          },
          focusin: event => {
            const trigger = getTrigger(event.target);
            if (trigger && (matchMedia('(hover: hover)').matches || trigger.matches(':focus-visible'))) setOpen(trigger, true);
          },
          focusout: event => {
            const trigger = getTrigger(event.target);
            if (trigger) setOpen(trigger, false);
          },
          click: event => {
            const trigger = getTrigger(event.target);
            if (!trigger || matchMedia('(hover: hover)').matches) return;
            event.stopPropagation();
            setOpen(trigger, event.detail === 0 || !trigger.classList.contains('is-preview-open'));
          }
        };
        Object.entries(listeners).forEach(([type, listener]) => section.addEventListener(type, listener));
        const stopMarquee = initializeMarquee(section, closeAll);
        section.hexagonPartnersCleanup = () => {
          stopMarquee();
          Object.entries(listeners).forEach(([type, listener]) => section.removeEventListener(type, listener));
          delete section.dataset.hexagonPartnersInitialized;
        };
      });
    };

    initialize();

    if (!window.hexagonPartnersSectionListener) {
      window.hexagonPartnersSectionListener = true;
      document.addEventListener('shopify:section:load', (event) => initialize(event.target));
      document.addEventListener('shopify:section:unload', (event) => {
        const section = event.target.matches?.('[data-hexagon-partners]') ? event.target : event.target.querySelector?.('[data-hexagon-partners]');
        section?.hexagonPartnersCleanup?.();
        const sectionId = section?.id?.replace('HexagonPartners-', '');
        if (!sectionId) return;
        document.querySelectorAll(`[data-hexagon-preview-owner="${sectionId}"]`).forEach((preview) => preview.remove());
      });
      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-hexagon-preview-trigger]')) return;
        closeOpenPreviews();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeOpenPreviews();
      });
      window.addEventListener('resize', placeOpenPreviews);
      window.addEventListener('scroll', placeOpenPreviews, true);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sinocrafted-collection-list')) {
    customElements.define('sinocrafted-collection-list', class extends HTMLElement {
      connectedCallback() {
        // Wait until the parser has attached this instance's children. This also
        // covers sections inserted after the element is already registered.
        if (this.controller || this.initFrame) return;
        this.initFrame = requestAnimationFrame(() => {
          this.initFrame = 0;
          if (this.isConnected) this.initialize();
        });
      }
      initialize() {
        if (this.controller) return;
        this.list = this.querySelector('[data-scfc-list]');
        if (!this.list) return;
        this.track = this.querySelector('[data-scfc-track]');
        this.thumb = this.querySelector('[data-scfc-thumb]');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal, passive: true };
        this.schedule = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.updateProgress();
          });
        };
        this.list.addEventListener('scroll', this.schedule, options);
        window.addEventListener('resize', this.schedule, options);
        this.bindDragControls();
        this.addEventListener('shopify:block:select', (event) => {
          const item = event.target.closest('.scfc-item');
          if (item && this.contains(item) && window.matchMedia('(max-width: 749px)').matches) {
            const offset = item.getBoundingClientRect().left - this.list.getBoundingClientRect().left;
            this.list.scrollBy({ left: offset, behavior: 'instant' });
          }
        }, { signal: this.controller.signal });
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.observeSizes = () => {
          this.resizeObserver.disconnect();
          this.resizeObserver.observe(this.list);
          Array.from(this.list.children).forEach(item => this.resizeObserver.observe(item));
        };
        this.observeSizes();
        this.mutationObserver = new MutationObserver(() => {
          this.list.scrollLeft = 0;
          this.observeSizes();
          this.schedule();
        });
        this.mutationObserver.observe(this.list, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
        this.schedule();
      }
      updateProgress() {
        if (!this.track || !this.thumb) return;
        const visible = this.list.clientWidth;
        const total = this.list.scrollWidth;
        const distance = total - visible;
        this.track.hidden = distance <= 1 || !window.matchMedia('(max-width: 749px)').matches;
        if (this.track.hidden) return;
        const portion = visible / total;
        const position = Math.min(distance, Math.max(0, Math.abs(this.list.scrollLeft))) / distance;
        this.track.setAttribute('aria-valuenow', Math.round(position * 100));
        this.thumb.style.width = `${portion * 100}%`;
        const rtl = getComputedStyle(this.list).direction === 'rtl';
        this.thumb.style.left = `${(rtl ? 1 - position : position) * (1 - portion) * 100}%`;
      }
      bindDragControls() {
        const signal = this.controller.signal;
        const mobile = () => window.matchMedia('(max-width: 749px)').matches;
        const rtl = () => getComputedStyle(this.list).direction === 'rtl';
        const setProgress = (progress) => {
          const distance = this.list.scrollWidth - this.list.clientWidth;
          this.list.scrollLeft = (rtl() ? -1 : 1) * Math.max(0, Math.min(1, progress)) * distance;
          this.updateProgress();
        };
        this.endDrag = () => {
          const drag = this.drag;
          if (!drag) return;
          this.drag = null;
          if (drag.target.hasPointerCapture(drag.id)) drag.target.releasePointerCapture(drag.id);
          this.removeAttribute('data-dragging');
        };
        const move = (event) => {
          const drag = this.drag;
          if (!drag || drag.id !== event.pointerId) return;
          if (drag.type === 'track') {
            const bounds = this.track.getBoundingClientRect();
            const travel = bounds.width - this.thumb.getBoundingClientRect().width;
            if (travel > 0) {
              const visual = (event.clientX - bounds.left - drag.offset) / travel;
              setProgress(rtl() ? 1 - visual : visual);
            }
          } else {
            const delta = event.clientX - drag.x;
            if (!drag.moved && Math.abs(delta) < 5) return;
            if (!drag.moved) {
              drag.moved = true;
              this.setAttribute('data-dragging', '');
              this.list.setPointerCapture(event.pointerId);
            }
            this.suppressClickUntil = performance.now() + 500;
            this.list.scrollLeft = drag.scroll - delta;
            this.updateProgress();
          }
        };
        const finish = (event) => {
          if (this.drag?.id === event.pointerId) this.endDrag();
        };
        this.list.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || !mobile() || this.list.scrollWidth <= this.list.clientWidth + 1) return;
          this.drag = { type: 'list', target: this.list, id: event.pointerId, x: event.clientX, scroll: this.list.scrollLeft, moved: false };
        }, { signal });
        this.list.addEventListener('dragstart', (event) => {
          if (mobile()) event.preventDefault();
        }, { signal });
        this.list.addEventListener('click', (event) => {
          if (performance.now() < (this.suppressClickUntil || 0)) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, { signal, capture: true });
        if (this.track) {
          this.track.addEventListener('pointerdown', (event) => {
            if (event.button !== 0 || !event.isPrimary || !mobile()) return;
            event.preventDefault();
            const thumb = this.thumb.getBoundingClientRect();
            const inside = event.clientX >= thumb.left && event.clientX <= thumb.right;
            this.drag = { type: 'track', target: this.track, id: event.pointerId, offset: inside ? event.clientX - thumb.left : thumb.width / 2 };
            this.setAttribute('data-dragging', '');
            this.track.setPointerCapture(event.pointerId);
            this.track.focus({ preventScroll: true });
            move(event);
          }, { signal });
          this.track.addEventListener('keydown', (event) => {
            const direction = rtl() ? -1 : 1;
            const distance = this.list.scrollWidth - this.list.clientWidth;
            if (distance <= 1) return;
            let progress = Math.abs(this.list.scrollLeft) / distance;
            const step = this.list.clientWidth / distance;
            if (event.key === 'Home') progress = 0;
            else if (event.key === 'End') progress = 1;
            else if (event.key === 'ArrowRight') progress += direction * step;
            else if (event.key === 'ArrowLeft') progress -= direction * step;
            else return;
            event.preventDefault();
            this.setAttribute('data-dragging', '');
            setProgress(progress);
            this.removeAttribute('data-dragging');
          }, { signal });
        }
        // Pointer capture keeps drag events on this Section, including when the
        // pointer leaves its bounds. Touch on cards remains native scrolling.
        this.addEventListener('pointermove', move, { signal });
        this.addEventListener('pointerup', finish, { signal });
        this.addEventListener('pointercancel', finish, { signal });
        this.addEventListener('lostpointercapture', finish, { signal });
        this.list.addEventListener('pointerleave', (event) => {
          if (this.drag?.type === 'list' && !this.drag.moved) finish(event);
        }, { signal });
      }
      disconnectedCallback() {
        this.endDrag?.();
        cancelAnimationFrame(this.initFrame);
        this.initFrame = 0;
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-signup-banner"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    class SignupBanner extends HTMLElement {
      constructor() {
        super();

        this.signupForm = this.querySelector('.newsletter-form');

        if (this.signupForm) {
          this.submitButton = this.signupForm.querySelector('button[type="submit"]');

          if (this.submitButton) {
            this.submitButton.removeAttribute('disabled');
          }

          clearInputErrors(this.signupForm);

          this.signupForm.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }

      handleSubmit(evt) {
        const formIsValid = validateForm(this.signupForm);

        if (formIsValid) {
          if (this.submitButton) {
            this.submitButton.classList.add('btn--loading');
          }
        } else {
          evt.preventDefault();
        }
      }
    }

    customElements.define('signup-banner', SignupBanner);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-linked-menu"]) return;
  try {
    
  class FaqLinkedMenu extends HTMLElement {
    constructor() {
      super();
      this.faqLinkedMenuContent = this.querySelector('.faq-linked-menu-content');
      this.accordionComponent = document.querySelectorAll('.faq-item');
      const faqlinkedItems = [];

      this.accordionComponent.forEach((elm, i) => {
        if (i != 0) {
          elm.classList.add('hide');
        }

        const faqLinkedMenuSection = elm.querySelector('[data-menu-info="faq-linked-menu"]');

        if (faqLinkedMenuSection) {
          const newMenuItem = document.createElement('li');
          newMenuItem.dataset.linkType = elm.dataset.sectionType;
          newMenuItem.innerHTML = faqLinkedMenuSection.innerHTML;

          if (i === 0) {
            newMenuItem.classList.add('active');
          }

          this.faqLinkedMenuContent.appendChild(newMenuItem);

          newMenuItem.addEventListener('click', this.handleClick.bind(this));
        }

        faqLinkedMenuSection.classList.add('hide');
      });
    }

    handleClick(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const contentId = target.dataset.linkType;

      const activeElement = document.querySelector(`[data-section-type=${contentId}]`);
      const activeHeaderItem = this.faqLinkedMenuContent.querySelector('li.active');

      if (activeHeaderItem !== target) {
        activeHeaderItem.classList.remove('active');
        target.classList.add('active');
      }

      this.accordionComponent.forEach((elm) => {
        if (!elm.classList.contains('hide')) {
          elm.classList.add('collapsible-content--hide');
          setTimeout(function () {
            elm.classList.add('hide');
          }, 200);
        }
      });

      setTimeout(function () {
        activeElement.classList.remove('hide');
        activeElement.classList.remove('collapsible-content--hide');
      }, 200);
    }
  }

  customElements.define('faq-linked-menu', FaqLinkedMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.background = this.getAttribute('data-background');
      this.applyColorScheme = this.getAttribute('data-color-scheme');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.headerSearch = this.querySelector('.header__search');

      this.headerHeight = this.header.getBoundingClientRect().height;
      this.headerWrap = this.header.querySelector('.header-wrapper');
      this.isFrosted = this.headerWrap.dataset.frosted;
      this.isSticky = this.headerWrap.dataset.sticky;
      this.menuInline = this.header.querySelector('.list-menu--inline');
      this.activeMenuItem = this.header.querySelector('.header__active-menu-item');
      this.listMenuItems = this.header.querySelectorAll('.header__inline-menu .list-menu__item-list');

      this.openingMenu = false;
      this.closingMenu = false;
      this.isFadeOutTransition = false;
      this.listMenuItems.forEach((listMenuItem) => listMenuItem.addEventListener('mouseenter', this.handleMouseEnter.bind(this)));
      this.listMenuItems.forEach((listMenuItem) => listMenuItem.addEventListener('mouseleave', this.handleMouseleave.bind(this)));
      this.listMenuItems.forEach((listMenuItem) => listMenuItem.addEventListener('click', this.handleClick.bind(this)));

      if (this.isSticky) {
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      const searchHomeField = document.getElementById('search-home-field');
      let headerHeight = this.header.getBoundingClientRect().height;
      if (searchHomeField) {
        headerHeight = headerHeight + searchHomeField.getBoundingClientRect().height;
        if (document.querySelector('.shopify-section:first-child [allow-transparent-header]')) {
          searchHomeField.classList.add('search-home--transparent');
        }
      }
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
      let prevHeight = 0;
      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          if (entry.contentBoxSize) {
            const height = entry.contentBoxSize?.[0].blockSize;
            if (typeof height === 'number' && height !== prevHeight) {
              prevHeight = height;
              let headerHeight = this.header.getBoundingClientRect().height;
              if (searchHomeField) {
                headerHeight = headerHeight + searchHomeField.getBoundingClientRect().height;
              }
              document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
            }
          }
        }
      });

      resizeObserver.observe(this.header);
      this.setupTransparency();
      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.setupTransparency.bind(this));
        document.addEventListener('shopify:section:unload', this.setupTransparency.bind(this));
        document.addEventListener('shopify:section:reorder', this.setupTransparency.bind(this));
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.headerSearch && this.headerSearch.isOpen()) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (!this.applyColorScheme) {
        this.header.classList.add(this.background);
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      if (!this.applyColorScheme) {
        this.header.classList.add(this.background);
      }
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );

      if (!this.applyColorScheme) {
        this.header.classList.remove(this.background);
      }
    }

    handleClick(event) {
      const menuItem = event.target;
      const detailsElement = menuItem.querySelector('.details--list-menu');

      this.header.classList.add(this.background, 'is-filled');

      if (detailsElement) {
        setTimeout(() => {
          detailsElement.classList.add('sub-menu-opening');
        });
      }
    }

    handleMouseEnter(event) {
      const menuItem = event.target;
      const menuItemSpan = menuItem.querySelector('.header__menu-item');
      const detailsElement = menuItem.querySelector('.details--list-menu');
      const currentSubmenu = this.menuInline.querySelector('details[open]');

      this.header.querySelectorAll('.header__active-menu-item').forEach((elm) => {
        elm.classList.remove('header__active-menu-item');
      });
      menuItemSpan.classList.add('header__active-menu-item');

      if (!detailsElement) return;

      if (this.closingMenu && detailsElement.getAttribute('open') && !this.isFadeOutTransition) {
        window.clearTimeout(this.timeoutClose);
        this.closingMenu = false;
      }

      if (detailsElement.getAttribute('open') && !this.isFadeOutTransition) return;

      window.clearTimeout(this.timeoutOpen);
      this.openingMenu = true;

      this.timeoutOpen = setTimeout(() => {
        this.openingMenu = false;
        this.openSubMenu(detailsElement);
      }, 300);
    }

    openSubMenu(detailsElement) {
      detailsElement.setAttribute('open', true);
      if (this.isFrosted) this.headerWrap.classList.remove('frosted-header-glass');
      this.header.classList.add(this.background, 'is-filled');
      this.closeMenuLocalization();
      setTimeout(() => {
        detailsElement.classList.add('sub-menu-opening');
      });
    }

    handleMouseleave(event) {
      const menuItem = event.target;
      const detailsElement = menuItem.querySelector('.details--list-menu');
      const currentSubmenu = this.menuInline.querySelector('details[open]');

      this.header.querySelectorAll('.header__active-menu-item').forEach((elm) => {
        elm.classList.remove('header__active-menu-item');
      });

      if (this.activeMenuItem) this.activeMenuItem.classList.add('header__active-menu-item');

      if (!detailsElement) return;

      if (this.openingMenu && !detailsElement.getAttribute('open')) {
        window.clearTimeout(this.timeoutOpen);
        this.openingMenu = false;
      }

      if (!detailsElement.getAttribute('open')) return;

      this.closingMenu = true;
      this.timeoutClose = setTimeout(() => {
        this.closingMenu = false;
        this.closeSubMenu(detailsElement);
      }, 300);
    }

    closeSubMenu(detailsElement) {
      if (this.isFrosted) this.headerWrap.classList.add('frosted-header-glass');
      this.header.classList.remove('is-filled');
      if (!this.header.classList.contains('animate')) {
        this.header.classList.remove(this.background);
      }

      detailsElement.classList.remove('sub-menu-opening');
      this.isFadeOutTransition = true;

      detailsElement.addEventListener(
        'transitionend',
        () => {
          detailsElement.removeAttribute('open');
          this.isFadeOutTransition = false;
        },
        { once: true }
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeMenuLocalization() {
      this.headerLocalization = this.headerLocalization || this.header.querySelectorAll('localization-form');
      this.headerLocalization.forEach((disclosure) => disclosure.hidePanel());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        // this.searchModal.close(false);
      }
    }

    setupTransparency() {
      if (this.dataset.homeOverlay === 'true' || document.querySelector('.shopify-section:first-child [allow-transparent-header]')) {
        this.classList.add(this.background);
        this.setAttribute('data-transparency', true);
      } else {
        if (this.isSticky && !this.applyColorScheme) {
          this.classList.remove(this.background);
        }
        this.removeAttribute('data-transparency');
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '[data-hero-video-audio-volume]';

    const initializeVideoVolume = (section) => {
      if (section.dataset.heroVideoAudioReady === 'true') return;

      const video = section.querySelector('.hero__media video');
      const configuredVolume = section.dataset.heroVideoAudioVolume;
      const volume = configuredVolume === '' ? 80 : Number(configuredVolume);

      if (!video || !Number.isFinite(volume)) return;

      section.dataset.heroVideoAudioReady = 'true';
      video.volume = Math.min(Math.max(volume, 0), 100) / 100;
    };

    const initializeVideoVolumes = (container = document) => {
      container.querySelectorAll(sectionSelector).forEach(initializeVideoVolume);
    };

    initializeVideoVolumes();
    document.addEventListener('shopify:section:load', (event) => initializeVideoVolumes(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  class newsletterForm extends HTMLElement {
    constructor() {
      super();
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);

      const sectionId = this.dataset.sectionId;
      const contactNewsletter = this.querySelector(`#Contact_${sectionId}`);
      const inputEmailGroup = contactNewsletter.querySelector('.input-group');
      const inputEmailNewsletter = contactNewsletter.querySelector('input[type="email"]');
      const errorMessage = contactNewsletter.querySelector(`#Newsletter-error--${sectionId}`);
      const errorMessageText = errorMessage.querySelector('.input-error-message__text');
      const iconError = contactNewsletter.querySelector('.field-wrapper__icon-error');
      const existingEmailMsg = contactNewsletter.querySelector('.newsletter-email-exist');
      const urlUserCame = document.referrer ? new URL(document.referrer) : null;

      inputEmailNewsletter.addEventListener('keyup', function (e) {
        if (e.code === 'Enter') return;
        inputEmailGroup.classList.remove('input-group--error');
        inputEmailNewsletter.classList.remove('input--error');
        errorMessage.classList.add('hide');
        iconError.classList.add('hide');
        if (existingEmailMsg) existingEmailMsg.classList.add('hide');
      });

      if (existingEmailMsg && searchParams.has('form_type') && inputEmailNewsletter.value) {
        existingEmailMsg.classList.remove('hide');
      }

      if ( urlUserCame && urlUserCame.pathname === '/challenge' ) {
        document.querySelector(`#Contact_${sectionId}`).scrollIntoView();
      }

      contactNewsletter.addEventListener('submit', (event) => {
        const email = inputEmailNewsletter.value;

        if (!this.validateEmail(email)) {
          event.preventDefault();
          var erroMessage = '';

          if (email === '') {
            erroMessage = window.loginStrings.errorEmailRequired;
          } else {
            erroMessage = window.loginStrings.errorEmailInvalid;
          }

          inputEmailGroup.classList.add('input-group--error');
          inputEmailNewsletter.classList.add('input--error');
          inputEmailNewsletter.setAttribute('aria_invalid', 'true');
          inputEmailNewsletter.setAttribute('aria_describedby', `Newsletter-error--${sectionId}`);
          inputEmailNewsletter.setAttribute('data_form_status', true);

          if (errorMessageText) errorMessageText.textContent = erroMessage;
          errorMessage.classList.remove('hide');
          iconError.classList.remove('hide');
          inputEmailNewsletter.focus();
        }

        return false;
      });
    }

    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }

  customElements.define('newsletter-form', newsletterForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-detail-navigation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-detail-nav')) {
    class ProductDetailNav extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected && !this.controller) this.initialize(); });
      }
      initialize() {
        this.controller = new AbortController();
        this.signal = this.controller.signal;
        this.placeholder = this.querySelector('.pdn__slot');
        this.surface = this.querySelector('.pdn__surface');
        this.trigger = this.querySelector('.pdn__trigger');
        this.menu = this.querySelector('.pdn__menu');
        this.list = this.querySelector('.pdn__list');
        this.moreButton = this.querySelector('.pdn__more');
        this.preview = this.querySelector('.pdn__preview-text');
        this.strings = JSON.parse(this.querySelector('.pdn__strings').textContent);
        this.editor = this.querySelector('.pdn__editor');
        this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width: 749px)');
        this.records = Array.from(this.querySelectorAll('.pdn__item'), (element) => ({
          element, link: element.querySelector('a'), title: element.querySelector('.pdn__label').textContent.trim(),
          preview: element.dataset.preview, id: element.dataset.target.replace(/^#/, '').trim(),
          offset: Number(element.dataset.offset) || 0
        }));
        this.valid = [];
        this.previewIndex = 0;
        this.inView = true;
        this.lastY = window.scrollY;
        this.listen(this, 'click', (event) => this.handleClick(event));
        this.listen(document, 'click', (event) => { if (!this.contains(event.target)) { this.setOpen(false, false); this.setBarExpanded(false, false); } });
        this.listen(document, 'keydown', (event) => this.handleKey(event));
        this.listen(window, 'scroll', () => {
          this.requestUpdate();
          if (this.navigation) this.scheduleSettle();
        }, { passive: true });
        this.listen(window, 'resize', () => this.refreshSoon());
        this.listen(window, 'pageshow', () => this.refreshSoon());
        this.listen(window, 'wheel', () => this.cancelNavigation(), { passive: true });
        this.listen(window, 'touchstart', () => this.cancelNavigation(), { passive: true });
        this.listen(document, 'visibilitychange', () => this.syncRotation());
        this.listen(this.surface, 'pointerenter', (event) => { if (event.pointerType === 'mouse') { this.hovered = true; this.syncRotation(); } });
        this.listen(this.surface, 'pointerleave', () => { this.hovered = false; this.syncRotation(); });
        this.listen(this.surface, 'focusin', () => this.syncRotation());
        this.listen(this.surface, 'focusout', () => { clearTimeout(this.focusTimer); this.focusTimer = setTimeout(() => this.syncRotation(), 0); });
        this.listen(this.trigger, 'pointerdown', (event) => this.startDrag(event));
        this.listen(this.trigger, 'pointermove', (event) => this.moveDrag(event));
        this.listen(this.trigger, 'pointerup', (event) => this.finishDrag(event));
        this.listen(this.trigger, 'pointercancel', (event) => this.finishDrag(event));
        this.listen(this.mobile, 'change', () => this.refresh());
        this.listen(this.reduce, 'change', () => this.syncRotation());
        this.listen(document, 'transitionrun', (event) => {
          if (this.headerCandidates?.some((element) => element === event.target || element.contains(event.target) || event.target.contains(element))) {
            this.headerAnimatingUntil = performance.now() + 1000;
            this.requestUpdate();
          }
        }, { capture: true });
        this.listen(document, 'transitionend', (event) => {
          if (this.headerCandidates?.some((element) => element === event.target || element.contains(event.target) || event.target.contains(element))) {
            this.headerAnimatingUntil = 0;
            this.requestUpdate();
          }
        }, { capture: true });
        if (window.visualViewport) this.listen(window.visualViewport, 'resize', () => this.requestUpdate());
        ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((name) => this.listen(document, name, () => this.refreshSoon()));
        this.listen(document, 'shopify:block:select', (event) => {
          const item = this.valid.find((record) => record.element.dataset.blockId === event.detail.blockId);
          if (item) {
            this.setOpen(true);
            if (this.valid.indexOf(item) >= 3) this.setBarExpanded(true);
            this.previewIndex = this.valid.indexOf(item);
            this.showPreview(false);
            item.link.focus({ preventScroll: true });
          }
        });
        this.resizeObserver = new ResizeObserver(() => this.requestUpdate());
        this.resizeObserver.observe(document.body);
        this.resizeObserver.observe(this.surface);
        this.intersectionObserver = new IntersectionObserver((entries) => {
          this.inView = entries[0].isIntersecting;
          this.syncRotation();
        });
        this.intersectionObserver.observe(this.surface);
        this.mutationObserver = new MutationObserver((mutations) => {
          if (mutations.some((mutation) => !this.contains(mutation.target) && !mutation.target.closest?.('product-detail-nav'))) this.refreshSoon();
        });
        this.mutationObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'open', 'aria-hidden'] });
        if (this.editor) this.initializeEditor();
        this.refresh();
      }
      listen(target, name, callback, options = {}) { target.addEventListener(name, callback, { ...options, signal: this.signal }); }
      flag(name) { return this.dataset[name] === 'true'; }
      px(name) { return parseFloat(getComputedStyle(this).getPropertyValue(name)) || 0; }
      isMobileOrb() { return this.mobile.matches && this.dataset.mode === 'orb'; }
      dragBounds(width, height) {
        const viewportWidth = window.visualViewport?.width || innerWidth;
        const viewportHeight = window.visualViewport?.height || innerHeight;
        const edge = Math.max(8, this.px('--pdn-edge'));
        const minTop = Math.max(8, this.headerHeight + this.topGap + 8);
        return {
          viewportWidth,
          minLeft: edge,
          maxLeft: Math.max(edge, viewportWidth - width - edge),
          minTop,
          maxTop: Math.max(minTop, viewportHeight - height - 16)
        };
      }
      placeDraggedOrb(left, top, width, height) {
        const bounds = this.dragBounds(width, height);
        const nextLeft = Math.max(bounds.minLeft, Math.min(bounds.maxLeft, left));
        const nextTop = Math.max(bounds.minTop, Math.min(bounds.maxTop, top));
        this.dataset.dragged = 'true';
        this.dataset.dragSide = nextLeft + width / 2 < bounds.viewportWidth / 2 ? 'left' : 'right';
        this.style.setProperty('--pdn-drag-left', nextLeft + 'px');
        this.style.setProperty('--pdn-drag-top', nextTop + 'px');
        return { ...bounds, left: nextLeft, top: nextTop };
      }
      startDrag(event) {
        if (!this.isMobileOrb() || !this.flag('mobileDrag') || this.dataset.show !== 'true' || event.isPrimary === false || (event.pointerType === 'mouse' && event.button !== 0)) return;
        const rect = this.surface.getBoundingClientRect();
        this.drag = { pointerId: event.pointerId, startX: event.clientX, startY: event.clientY, left: rect.left, top: rect.top, width: rect.width, height: rect.height, moved: false };
        this.dataset.dragging = 'true';
        try { this.trigger.setPointerCapture?.(event.pointerId); } catch {}
        this.syncRotation();
      }
      moveDrag(event) {
        const drag = this.drag;
        if (!drag || drag.pointerId !== event.pointerId) return;
        const offsetX = event.clientX - drag.startX;
        const offsetY = event.clientY - drag.startY;
        if (!drag.moved && Math.max(Math.abs(offsetX), Math.abs(offsetY)) < 6) return;
        if (!drag.moved) { drag.moved = true; this.setOpen(false, false); }
        event.preventDefault();
        drag.position = this.placeDraggedOrb(drag.left + offsetX, drag.top + offsetY, drag.width, drag.height);
        this.requestUpdate();
      }
      finishDrag(event) {
        const drag = this.drag;
        if (!drag || drag.pointerId !== event.pointerId) return;
        try { this.trigger.releasePointerCapture?.(event.pointerId); } catch {}
        this.drag = null;
        this.dataset.dragging = 'false';
        if (!drag.moved) { this.syncRotation(); return; }
        const position = drag.position || this.placeDraggedOrb(drag.left, drag.top, drag.width, drag.height);
        const side = position.left + drag.width / 2 < position.viewportWidth / 2 ? 'left' : 'right';
        this.dataset.dragSide = side;
        this.style.setProperty('--pdn-drag-left', (side === 'left' ? position.minLeft : position.maxLeft) + 'px');
        this.style.setProperty('--pdn-drag-top', position.top + 'px');
        this.dragSuppressUntil = performance.now() + 350;
        this.syncRotation();
        this.requestUpdate();
      }
      resolveTarget(value) {
        let id = String(value || '').trim().replace(/^#/, '');
        if (!id) return null;
        let exact = document.getElementById(id);
        if (exact) return exact;
        try { id = decodeURIComponent(id); } catch {}
        exact = document.getElementById(id);
        if (exact) return exact;
        const savedSection = id.match(/^(?:shopify-section-)?template--[^_]+__(.+)$/);
        const key = savedSection ? savedSection[1] : id;
        const namespace = this.dataset.sectionId.match(/^(template--[^_]+)__/);
        return namespace ? document.getElementById('shopify-section-' + namespace[1] + '__' + key) : null;
      }
      portableTarget(target) {
        const section = target.id.match(/^shopify-section-template--[^_]+__(.+)$/);
        return '#' + (section ? section[1] : target.id);
      }
      visible(element) {
        if (!element?.isConnected || !element.getClientRects().length) return false;
        const style = getComputedStyle(element);
        return style.display !== 'none' && style.visibility !== 'hidden' && !element.closest('[hidden], [aria-hidden="true"]');
      }
      refreshSoon() {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(() => { if (this.isConnected) this.refresh(); }, 80);
      }
      refresh() {
        const previousMode = this.dataset.mode;
        const previousMobile = this.dataset.mobile;
        this.dataset.mobile = String(this.mobile.matches);
        this.dataset.mode = this.mobile.matches && this.dataset.mobileMode !== 'inherit' ? this.dataset.mobileMode : this.dataset.desktopMode;
        this.dataset.side = this.mobile.matches && this.dataset.sideMobile !== 'inherit' ? this.dataset.sideMobile : this.dataset.sideDesktop;
        this.dataset.show = String(this.flag('enabled') && this.flag(this.mobile.matches ? 'mobileShow' : 'desktopShow'));
        this.headerCandidates = Array.from(document.querySelectorAll('sticky-header, header, .shopify-section-header, .announcement-bar-section, [data-pdn-obstruction]')).filter((element) => !this.contains(element));
        this.valid = this.records.filter((record) => {
          record.target = this.resolveTarget(record.id);
          record.error = !record.title ? 'empty_title' : !record.id ? 'empty_target' : !record.target ? 'missing_target' : this.contains(record.target) || record.target.contains(this) ? 'self_target' : !this.visible(record.target) ? 'hidden_target' : '';
          record.element.hidden = Boolean(record.error);
          if (!record.error) record.link.setAttribute('href', '#' + encodeURIComponent(record.target.id));
          return !record.error;
        });
        this.dataset.empty = String(this.valid.length === 0);
        this.style.setProperty('--pdn-mobile-columns', String(Math.max(1, Math.min(4, this.valid.length))));
        this.valid.forEach((record, index) => { record.element.dataset.secondRow = String(index >= 4); });
        this.dataset.mobileFold = String(this.mobile.matches && this.dataset.mode === 'bar' && this.flag('mobileCollapse') && this.valid.length > 4);
        if (this.dataset.mobileFold !== 'true') this.setBarExpanded(false, false);
        if (previousMode !== this.dataset.mode || previousMobile !== this.dataset.mobile) { this.slotHeight = 0; this.setBarExpanded(false, false); }
        this.dataset.ready = 'true';
        this.previewIndex = this.previewIndex % Math.max(1, this.valid.length);
        if (previousMode !== this.dataset.mode || this.dataset.show === 'false' || !this.valid.length) this.setOpen(false, false);
        this.showPreview(false);
        this.update();
        if (this.editor) this.updateEditor();
      }
      requestUpdate() {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      }
      obstructionHeight() {
        const spans = [];
        for (const element of this.headerCandidates || []) {
          if (!this.visible(element)) continue;
          let ancestor = element;
          let positioned = false;
          for (let depth = 0; ancestor && ancestor !== document.body && depth < 6; depth++, ancestor = ancestor.parentElement) {
            if (/^(fixed|sticky)$/.test(getComputedStyle(ancestor).position)) { positioned = true; break; }
          }
          if (!positioned) continue;
          const rect = element.getBoundingClientRect();
          if (rect.bottom > 0 && rect.height < innerHeight * 0.65 && rect.width > innerWidth * 0.45) spans.push(rect);
        }
        spans.sort((a, b) => a.top - b.top);
        let bottom = 0;
        spans.forEach((rect) => { if (rect.top <= bottom + 3) bottom = Math.max(bottom, rect.bottom); });
        return Math.max(0, bottom + (Number(this.dataset.headerOffset) || 0));
      }
      isObscured() {
        const surface = this.surface?.getBoundingClientRect();
        if (!surface || surface.width <= 0 || surface.height <= 0) return false;
        return Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], .product-media-modal[open], [data-pdn-modal][open]')).some((element) => {
          if (this.contains(element) || !this.visible(element)) return false;
          const style = getComputedStyle(element);
          if (style.pointerEvents === 'none' || parseFloat(style.opacity) <= 0.02) return false;
          const rect = element.getBoundingClientRect();
          return rect.right > surface.left && rect.left < surface.right && rect.bottom > surface.top && rect.top < surface.bottom;
        });
      }
      update() {
        if (!this.controller || !this.surface) return;
        this.headerHeight = this.obstructionHeight();
        this.topGap = this.px('--pdn-top-gap');
        this.dataset.obscured = String(this.isObscured());
        const available = this.dataset.show === 'true' && this.valid.length > 0;
        const rect = this.placeholder.getBoundingClientRect();
        const height = Math.ceil(this.surface.getBoundingClientRect().height);
        this.navHeight = height;
        this.slotPageTop = rect.top + window.scrollY;
        const threshold = this.headerHeight + this.topGap;
        const wasFixed = this.dataset.fixed === 'true';
        const mobileOrb = this.isMobileOrb();
        const fixed = available && (mobileOrb || (this.flag('sticky') && rect.top < threshold - (wasFixed ? 0 : 2)));
        if (mobileOrb) this.slotHeight = 0;
        else if (height > 0 && (!wasFixed || !fixed || !this.slotHeight)) this.slotHeight = height;
        this.style.setProperty('--pdn-slot-height', (this.slotHeight || 0) + 'px');
        this.dataset.fixed = String(fixed);
        this.style.setProperty('--pdn-fixed-top', threshold + 'px');
        const viewportHeight = window.visualViewport?.height || innerHeight;
        const desired = viewportHeight * Number(this.mobile.matches ? this.dataset.positionMobile : this.dataset.positionDesktop) / 100;
        const triggerHeight = Math.ceil(this.trigger?.getBoundingClientRect().height) || 48;
        const half = (mobileOrb ? triggerHeight : this.slotHeight || triggerHeight) / 2;
        const orbTop = Math.max(threshold + half + 8, Math.min(viewportHeight - half - 24, desired));
        this.style.setProperty('--pdn-orb-top', orbTop + 'px');
        const surfaceRect = this.surface.getBoundingClientRect();
        const above = surfaceRect.top - threshold - 12;
        const below = viewportHeight - surfaceRect.bottom - 24;
        const upward = below < Math.min(360, this.valid.length * 54 + 64) && above > below;
        this.dataset.panelUp = String(upward);
        this.style.setProperty('--pdn-panel-height', Math.max(44, upward ? above : below) + 'px');
        if (this.navigation) this.setActive(this.navigation.item);
        else this.updateActive();
        this.updateOutline();
        this.syncRotation();
        this.lastY = window.scrollY;
        if (performance.now() < (this.headerAnimatingUntil || 0)) this.requestUpdate();
      }
      updateActive() {
        if (!this.flag('highlight')) { this.setActive(null); return; }
        const readingLine = this.headerHeight + (this.dataset.mode === 'bar' && this.dataset.fixed === 'true' ? this.topGap + this.navHeight : 0) + (Number(this.dataset.scrollGap) || 0) + 3;
        const sorted = this.valid.slice().sort((a, b) => a.target.getBoundingClientRect().top - b.target.getBoundingClientRect().top);
        let current = null;
        sorted.forEach((item) => { if (item.target.getBoundingClientRect().top <= readingLine + item.offset) current = item; });
        if (window.scrollY + innerHeight >= document.documentElement.scrollHeight - 3) {
          sorted.forEach((item) => { if (item.target.getBoundingClientRect().top < innerHeight - 20) current = item; });
        }
        this.setActive(current);
      }
      setActive(item) {
        const next = this.flag('highlight') ? item : null;
        this.dataset.moreActive = String(Boolean(next?.element?.dataset.secondRow === 'true'));
        if (this.active === next) return;
        this.active = next;
        this.records.forEach((record) => {
          if (record === next) record.link.setAttribute('aria-current', 'location');
          else record.link.removeAttribute('aria-current');
        });
        if (next?.link && this.dataset.mode === 'bar' && !this.mobile.matches) {
          const container = this.list.getBoundingClientRect();
          const link = next.link.getBoundingClientRect();
          const delta = link.left < container.left ? link.left - container.left : link.right > container.right ? link.right - container.right : 0;
          if (delta) this.list.scrollBy({ left: delta, behavior: this.reduce.matches ? 'instant' : 'smooth' });
        }
      }
      setOpen(open, restoreFocus = true) {
        const next = Boolean(open && this.dataset.mode === 'orb' && this.valid.length);
        const changed = this.dataset.open !== String(next);
        this.dataset.open = String(next);
        this.trigger.setAttribute('aria-expanded', String(next));
        this.trigger.setAttribute('aria-label', next ? this.strings.close : this.strings.open);
        if (changed && !next && restoreFocus && this.menu.contains(document.activeElement)) this.trigger.focus({ preventScroll: true });
        this.syncRotation();
        this.requestUpdate();
      }
      setBarExpanded(expanded, restoreFocus = true) {
        const next = Boolean(expanded && this.dataset.mobileFold === 'true');
        const changed = this.dataset.barExpanded !== String(next);
        if (!next && changed && restoreFocus && document.activeElement?.closest('.pdn__item[data-second-row="true"]')?.closest('product-detail-nav') === this) this.moreButton.focus({ preventScroll: true });
        this.dataset.barExpanded = String(next);
        this.moreButton.setAttribute('aria-expanded', String(next));
        this.moreButton.setAttribute('aria-label', next ? this.strings.less : this.strings.more);
        if (changed) this.requestUpdate();
      }
      handleClick(event) {
        if (event.target.closest('.pdn__more')) this.setBarExpanded(this.dataset.barExpanded !== 'true');
        if (event.target.closest('.pdn__trigger')) {
          if (performance.now() < (this.dragSuppressUntil || 0)) { event.preventDefault(); return; }
          this.setOpen(this.dataset.open !== 'true');
          return;
        }
        if (event.target.closest('.pdn__close')) this.setOpen(false);
        const link = event.target.closest('.pdn__link');
        if (!link) return;
        const item = this.valid.find((record) => record.link === link);
        if (!item) return;
        event.preventDefault();
        if (this.flag('closeAfter')) { this.setOpen(false); this.setBarExpanded(false); this.update(); }
        this.navigate(item, event.detail === 0);
      }
      handleKey(event) {
        if (event.key === 'Escape') { this.setOpen(false); this.setBarExpanded(false); this.stopPicking(); }
        if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) this.cancelNavigation();
        if (event.key === 'ArrowDown' && event.target === this.trigger) { event.preventDefault(); this.setOpen(true); this.valid[0]?.link.focus(); }
      }
      destination(item) {
        this.headerHeight = this.obstructionHeight();
        const targetY = item.target.getBoundingClientRect().top + window.scrollY;
        let offset = this.headerHeight + (Number(this.dataset.scrollGap) || 0) + item.offset;
        if (this.flag('sticky') && this.dataset.mode === 'bar' && targetY > this.slotPageTop + 2) offset += this.topGap + (this.navHeight || 56);
        return Math.max(0, Math.min(document.documentElement.scrollHeight - innerHeight, targetY - offset));
      }
      navigate(item, keyboard = false) {
        this.cancelNavigation();
        if (!this.visible(item.target)) { this.refresh(); return; }
        this.navigation = { item, keyboard, corrections: 0 };
        this.setActive(item);
        window.scrollTo({ top: this.destination(item), behavior: this.flag('smooth') && !this.reduce.matches ? 'smooth' : 'instant' });
        this.scheduleSettle();
        this.navigationLimit = setTimeout(() => this.finishNavigation(), 2800);
      }
      scheduleSettle() {
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.settleNavigation(), 180);
      }
      settleNavigation() {
        if (!this.navigation) return;
        const destination = this.destination(this.navigation.item);
        if (Math.abs(window.scrollY - destination) > 3 && this.navigation.corrections < 2) {
          this.navigation.corrections++;
          window.scrollTo({ top: destination, behavior: 'instant' });
          this.scheduleSettle();
        } else this.finishNavigation();
      }
      finishNavigation() {
        const navigation = this.navigation;
        this.cancelNavigation();
        if (navigation?.keyboard && this.visible(navigation.item.target)) {
          const target = navigation.item.target.querySelector('h1, h2, h3') || navigation.item.target;
          const temporary = !target.hasAttribute('tabindex');
          if (temporary) target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
          if (temporary) target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
        }
        this.requestUpdate();
      }
      cancelNavigation() {
        clearTimeout(this.settleTimer);
        clearTimeout(this.navigationLimit);
        this.navigation = null;
      }
      showPreview(animate) {
        const text = this.valid[this.previewIndex]?.preview || '';
        if (this.preview.textContent === text) return;
        this.preview.textContent = text;
        if (animate && !this.reduce.matches) this.preview.animate([{ opacity: 0, transform: 'translateY(4px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 240, easing: 'ease-out' });
      }
      syncRotation() {
        if (!this.surface) return;
        const allowed = this.dataset.mode === 'orb' && this.dataset.show === 'true' && this.dataset.open !== 'true' && this.dataset.obscured !== 'true' && this.dataset.dragging !== 'true' && this.valid.length && this.inView && !this.hovered && !this.surface.contains(document.activeElement) && document.visibilityState === 'visible' && !this.reduce.matches;
        const needed = allowed && ((this.flag('rotate') && this.valid.length > 1) || this.flag('breathe'));
        if (!needed) { clearInterval(this.rotation); this.rotation = null; return; }
        if (this.rotation) return;
        this.rotation = setInterval(() => {
          if (this.flag('rotate') && this.valid.length > 1) { this.previewIndex = (this.previewIndex + 1) % this.valid.length; this.showPreview(true); }
          if (this.flag('breathe')) {
            const scale = 1 + (Number(this.dataset.intensity) || 0) / 100;
            this.querySelector('.pdn__ball').animate([{ transform: 'scale(1)' }, { transform: 'scale(' + scale + ')' }, { transform: 'scale(1)' }], { duration: 1100, easing: 'ease-in-out' });
            this.querySelector('.pdn__halo').animate([{ opacity: 0, transform: 'scale(0.9)' }, { opacity: 0.22, offset: 0.35 }, { opacity: 0, transform: 'scale(1.65)' }], { duration: 1300, easing: 'ease-out' });
          }
        }, Math.max(1, Number(this.dataset.interval) || 2) * 1000);
      }
      initializeEditor() {
        this.targetSelect = this.querySelector('.pdn__targets');
        this.resultInput = this.querySelector('.pdn__result');
        this.outline = this.querySelector('.pdn__outline');
        this.status = this.querySelector('.pdn__status');
        this.listen(this.targetSelect, 'change', () => this.selectTarget(document.getElementById(this.targetSelect.value)));
        this.listen(this.querySelector('[data-pdn-pick]'), 'click', () => {
          if (this.picking) this.stopPicking();
          else { this.picking = true; this.querySelector('[data-pdn-pick]').textContent = this.strings.cancel; this.status.textContent = this.strings.picking; }
        });
        this.listen(this.querySelector('[data-pdn-refresh]'), 'click', () => this.refresh());
        this.listen(this.querySelector('[data-pdn-copy]'), 'click', async () => {
          if (!this.resultInput.value) { this.status.textContent = this.strings.choose; return; }
          try { await navigator.clipboard.writeText(this.resultInput.value); this.status.textContent = this.strings.copied; }
          catch { this.resultInput.focus(); this.resultInput.select(); this.status.textContent = this.strings.copy_failed; }
        });
        this.listen(this.querySelector('[data-pdn-test]'), 'click', () => {
          const target = this.resolveTarget(this.resultInput.value);
          if (target) this.navigate({ target, offset: 0 }, false);
          else this.status.textContent = this.strings.choose;
        });
        this.listen(document, 'pointermove', (event) => {
          if (this.picking && !this.contains(event.target)) { this.outlinedTarget = this.pickCandidate(event.target); this.updateOutline(); }
        }, { passive: true });
        this.listen(document, 'click', (event) => {
          if (!this.picking || this.contains(event.target)) return;
          const target = this.pickCandidate(event.target);
          if (!target) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.selectTarget(target);
        }, { capture: true });
      }
      pickCandidate(element) {
        const section = element.closest?.('.shopify-section[id]');
        return section && this.pickTargets?.includes(section) ? section : null;
      }
      updateEditor() {
        const main = document.querySelector('main') || document.body;
        this.pickTargets = Array.from(main.querySelectorAll('.shopify-section[id]')).filter((element) => !element.contains(this) && !this.contains(element) && !element.closest('header, footer') && this.visible(element));
        const previous = this.targetSelect.value;
        this.targetSelect.replaceChildren(new Option(this.strings.choose, ''));
        this.pickTargets.forEach((element, index) => {
          const heading = element.querySelector('h1, h2, h3')?.textContent.trim().replace(/\s+/g, ' ').slice(0, 52);
          const suffix = element.id.replace(/^shopify-section-/, '').split('__').pop();
          this.targetSelect.add(new Option(String(index + 1).padStart(2, '0') + ' · ' + (heading || suffix) + ' [' + suffix + ']', element.id));
        });
        this.targetSelect.value = previous;
        this.querySelector('.pdn__count').textContent = '(' + this.valid.length + '/' + this.records.length + ')';
        const warnings = this.querySelector('.pdn__warnings');
        warnings.replaceChildren();
        if (this.dataset.show !== 'true') { const row = document.createElement('li'); row.textContent = this.strings.disabled; warnings.append(row); }
        this.records.forEach((record, index) => {
          const row = document.createElement('li');
          row.textContent = String(index + 1) + '. ' + (record.title || '—') + '：' + (record.error ? this.strings[record.error] : this.strings.valid);
          warnings.append(row);
        });
      }
      selectTarget(target) {
        if (!target) return;
        this.outlinedTarget = target;
        this.resultInput.value = this.portableTarget(target);
        this.targetSelect.value = target.id;
        this.status.textContent = this.strings.unsaved;
        this.stopPicking(false);
        this.updateOutline();
        clearTimeout(this.outlineTimer);
        this.outlineTimer = setTimeout(() => { if (!this.picking) { this.outlinedTarget = null; this.updateOutline(); } }, 4000);
      }
      stopPicking(clear = true) {
        this.picking = false;
        if (this.editor) this.querySelector('[data-pdn-pick]').textContent = this.strings.pick;
        if (clear) { this.outlinedTarget = null; this.updateOutline(); }
      }
      updateOutline() {
        if (!this.outline) return;
        this.outline.hidden = !this.outlinedTarget?.isConnected;
        if (this.outline.hidden) return;
        const rect = this.outlinedTarget.getBoundingClientRect();
        const top = Math.max(0, rect.top);
        Object.assign(this.outline.style, { top: top + 'px', left: rect.left + 'px', width: rect.width + 'px', height: Math.max(0, Math.min(innerHeight, rect.bottom) - top) + 'px' });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.mutationObserver?.disconnect();
        this.drag = null;
        this.dataset.dragging = 'false';
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        clearInterval(this.rotation);
        this.rotation = null;
        ['refreshTimer', 'focusTimer', 'outlineTimer'].forEach((name) => clearTimeout(this[name]));
        this.cancelNavigation();
      }
    }
    customElements.define('product-detail-nav', ProductDetailNav);
  }

  } catch(e) { console.error(e); }
})();
})();
